import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ValidationService } from '../shared/_services/validation.service';


@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss']
})
export class RegistrationComponent implements OnInit {
  
  registrationForm: any = FormGroup;
  public loading = false;
  mobnumPattern = "^((\\+91-?)|0)?[0-9]{10}$";
  spacePattern = "^(?!\s*$)X";
  error: boolean = false;
  success:boolean = false;
  errorMessage: String = "";
  successMessage: String = "";
  public modalRef: BsModalRef;
  config = {
    animated: true,
    keyboard: false,
    backdrop: true,
    ignoreBackdropClick: true,
    class: "registrationModal"
  };

  constructor(private fb: FormBuilder, private http: AuthService, private router: Router, private modalService: BsModalService, private validation: ValidationService) { }

  ngOnInit() {
    this.registrationForm = this.fb.group({
      firstName : ['', Validators.compose([Validators.minLength(1), this.noWhitespaceValidator, Validators.required])],
      lastName : ['', Validators.compose([Validators.minLength(1), this.noWhitespaceValidator, Validators.required])],
      // userName : ['', Validators.compose([Validators.required])],
      email : ['', [Validators.required, , Validators.pattern(this.validation.email_regexPattern)]],
      password : ['', [Validators.minLength(8), Validators.maxLength(15), Validators.required, Validators.pattern(this.validation.password_Pattern)]],
      phoneNumber  : ['', [Validators.maxLength(10), Validators.pattern(this.mobnumPattern)]]
    });
  }

  //validating white space in form control
  public noWhitespaceValidator(control: FormControl) {
    //console.log(control);
    let isWhitespace = (control.value || '').trim().length === 0;
    let isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true }
}
  //registration function
  registration(registrationData, modalData){
    var registrationObj = {
      email: decodeURI(registrationData.email.trim()),
      firstName: registrationData.firstName.trim(),
      lastName: registrationData.lastName.trim(),
      password: registrationData.password.trim(),
      phoneNumber: registrationData.phoneNumber.trim(),
    }
    this.loading = true;
    this.http.registrationAPi(registrationObj).subscribe(
      res=>{
        this.loading = false;
        if(res.error === 0){
          this.error = false;
          this.success = true;
          this.errorMessage = "";
          this.registrationForm.reset();
          this.successMessage = "Registration successful. Please check your email for credentials";
          this.modalRef = this.modalService.show(modalData, this.config);          
        }else{
          this.success = false;
          this.error = true;
          this.successMessage = "";
          // this.registrationForm.reset();
          this.errorMessage = res.message;
          this.modalRef = this.modalService.show(modalData, this.config);          
        }
      },
      error=>{
        this.loading = false;
        this.success = false;
        this.error = true;
        this.successMessage = "";
        this.errorMessage = error.message;
        // this.errorMessage = "Exception occured. Please try again";
        this.modalRef = this.modalService.show(modalData, this.config);          
        //console.log(this.errorMessage);
      }
    )
  }

  //clearing error messages
  // clearExisitingErrors(){
  //   this.success = false;
  //   this.error = false;
  //   this.errorMessage = "";
  //   this.successMessage = "";
  // }
  //redirect to login page upon clicking on ok button
  login(){
    this.modalRef.hide();
    this.router.navigate(['/login']);
  }
  ok(){
    this.modalRef.hide();
  }
  cancel(){
    this.router.navigate(['/login']);
  }
}



// WEBPACK FOOTER //
// ./src/app/registration/registration.component.ts